module.exports = __webpack_public_path__ + "files/494d82c68f6327043420e20b75d8895f.png";